var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Youtube = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" },
        React.createElement("g", __assign({ fill: "none" }, props),
            React.createElement("path", { className: "ic_background", fill: background, d: "M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20z" }),
            React.createElement("path", { className: "ic_filling", fill: color, d: "M32.8 16.674c0-3.024-2.496-5.474-5.573-5.474H12.773c-3.078 0-5.573 2.45-5.573 5.474v6.652c0 3.024 2.495 5.474 5.573 5.474h14.454c3.077 0 5.573-2.45 5.573-5.474v-6.652z" }),
            React.createElement("path", { fill: background, className: "ic_background", d: "M18.072 23.954c-.249.135-.472-.045-.472-.328v-6.452c0-.287.23-.466.478-.324l5.752 3.308c.254.145.21.514-.046.654l-5.712 3.142z" }))));
};
Youtube.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Youtube;
//# sourceMappingURL=Youtube.js.map